export const spaceNotAllowedRegex = /^\S*$/
export const emojiRegx = /^((?!(.*(\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]).*)).)*$/
export const specialCharNotAllowedRegx = /^[^\s?^+>^`~$^=|@][^+>^`~$^=|@]*$/
export const validContNo = /^[a-zA-Z]{4}\d{7}$/